var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Nav',{attrs:{"panel":_vm.panel}}),_c('transition',{attrs:{"name":"fade","appear":""}},[_c('router-view',{key:_vm.$route.fullPath,on:{"panel":_vm.setPanel}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }